export default __webpack_public_path__ + "static/media/outlook.a18f19a6.svg";